module.exports = __webpack_public_path__ + "img/Asset-201_1.36b8207d.png";